// ★ A8の発行コードを「一字一句」そのまま貼る
const BANNER_HTML = `
<a href="https://px.a8.net/svt/ejp?a8mat=45E6TY+5OT6F6+3AQG+TTLOX" rel="nofollow">
<img border="0" width="120" height="600" alt="" src="https://www25.a8.net/svt/bgt?aid=250924822344&wid=003&eno=01&mid=s00000015388005009000&mc=1"></a>
<img border="0" width="1" height="1" src="https://www14.a8.net/0.gif?a8mat=45E6TY+5OT6F6+3AQG+TTLOX" alt="">
`;

export default function RightRailAdRaw() {
  return (
    <div style={{ width: 120, minWidth: 120, textAlign: "center" }}>
      {/* 原文ママの広告コード */}
      <div dangerouslySetInnerHTML={{ __html: BANNER_HTML }} />

      {/* 追加する告知文言 */}
      <p
        style={{
          fontSize: "0.75rem",
          color: "#555",
          marginTop: "8px",
          lineHeight: 1.4,
        }}
      >
        当ページのリンクには広告が含まれています。
      </p>
    </div>
  );
}